export const STYLES = [
  { id: "watercolor", label: "Soft Watercolor", desc: "Dreamy pastel brushstrokes",
    swatch: "bg-gradient-to-br from-[#F2CC8F] to-[#81B29A]" },
  { id: "cartoon", label: "Whimsical Cartoon", desc: "Bold, playful & vibrant",
    swatch: "bg-gradient-to-br from-[#E07A5F] to-[#F2CC8F]" },
  { id: "classic", label: "Classic Storybook", desc: "Warm oil-painted heirloom",
    swatch: "bg-gradient-to-br from-[#6B4E71] to-[#1D2A44]" },
];

export default function StepStyle({ story, setStory }) {
  return (
    <div className="space-y-5" data-testid="step-3">
      <h1 className="font-display text-3xl font-bold text-[#2B2D42]">Pick an art style.</h1>
      <div className="grid sm:grid-cols-3 gap-4">
        {STYLES.map((s) => (
          <button key={s.id} data-testid={`style-${s.id}`} type="button"
            onClick={() => setStory({ ...story, illustration_style: s.id })}
            className={`paper-card p-5 text-left transition-all ${story.illustration_style === s.id ? "ring-2 ring-[#E07A5F] -translate-y-1" : "hover:-translate-y-0.5"}`}>
            <div className={`h-24 rounded-xl mb-3 ${s.swatch}`} />
            <div className="font-display text-xl font-bold text-[#2B2D42]">{s.label}</div>
            <div className="text-xs text-[#5C6370] mt-1">{s.desc}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
